const Constants = {
  ENV: process.env.VUE_APP_ENVIRONMENT,
  HH_COMPONENTS_URL: process.env.VUE_APP_HH_COMPONENTS_URL,
  ES_COMPONENTS_URL: process.env.VUE_APP_ES_COMPONENTS_URL,
  EMPLOYEE_HUB_API_BASE_URL: process.env.VUE_APP_EMPLOYEE_HUB_API_BASE_URL,
  ENTERPRISE_SEARCH_API_URL: process.env.VUE_APP_ENTERPRISE_SEARCH_API_URL,
  SELF_PAGE_TYPE:'SELF_PAGE',
  ERROR_MESSAGE:
    "There was an error that wasn’t your fault. Go get a cup of coffee, come back, and try again later or contact support.",
  NO_RECORDS_FOUND_MESSAGE: "There are no existing records for ",
  EH_URL: process.env.VUE_APP_EH_URL,
  EH_BASE_URL: 'https://employeehub.autodesk.com',
  LOCAL_EMPLOYEE_HUB_API_URL: 'https://api.dev.emphub-dev.autodesk.com/guidesmanagement',
  DEV_EMPLOYEE_HUB_API_URL: 'https://api.dev.emphub-dev.autodesk.com/guidesmanagement',
  QA_EMPLOYEE_HUB_API_URL: 'https://api.qa.emphub-dev.autodesk.com/guidesmanagement',
  TEST_EMPLOYEE_HUB_API_URL: 'https://api.test.emphub.autodesk.com/guidesmanagement',
  PRD_EMPLOYEE_HUB_API_URL: 'https://api.emphub.autodesk.com/guidesmanagement',
  SUPPORT_URL: "/support",
  GENERIC_SERVICE_TICKET_CATEGORY:'95844bb113577240df4573076144b0b2',
  INCIDENT_TICKET_CATEGORY:'3c6483f113577240df4573076144b0df',
  SEARCH_URL: "/search-results",
  DEV_MIXPANEL_TOKEN: "cef2430fd2b120a9ca79892927965ebc",
  QA_MIXPANEL_TOKEN: "cef2430fd2b120a9ca79892927965ebc", // Same as dev
  TEST_MIXPANEL_TOKEN: "4ea0a3a89003570ec8ea178329c79880",
  PRD_MIXPANEL_TOKEN: "f4e11a20e7892182b82a59c7a2dec2d1",
  SUPPORT_TITLE_CHECK_TEXT: "needmoresupport?"
};
export default Constants;
